/* Image + video Be Soft — indicador do carrossel no mobile.
   Marca qual painel esta em vista. Nao controla a rolagem: quem rola e o
   proprio scroll-snap do CSS, entao sem JS a secao continua funcionando,
   so o indicador fica parado no primeiro tracinho. */
(function () {
  "use strict";

  // Video so carrega quando chega perto da tela (e so ai toca, se tiver
  // autoplay). Sem IntersectionObserver, carrega na hora como antes.
  function loadVideo(video) {
    var source = video.querySelector("source[data-src]");
    if (!source) return;
    source.src = source.getAttribute("data-src");
    source.removeAttribute("data-src");
    video.load();
    if (video.hasAttribute("data-autoplay")) {
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
  }

  function setupVideos(section) {
    var videos = section.querySelectorAll("video[data-lazy-video]");
    if (!videos.length) return;
    if (!("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(videos, loadVideo);
      return;
    }
    var videoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          videoObserver.unobserve(entry.target);
          loadVideo(entry.target);
        });
      },
      { rootMargin: "200px 0px" }
    );
    Array.prototype.forEach.call(videos, function (video) {
      videoObserver.observe(video);
    });
  }

  function setup(section) {
    setupVideos(section);
    var scroller = section.querySelector("[data-media-split-scroller]");
    var indicator = section.querySelector("[data-media-split-indicator]");
    if (!scroller || !indicator) return;

    var panels = Array.prototype.slice.call(
      section.querySelectorAll("[data-media-split-panel]")
    );
    var dashes = Array.prototype.slice.call(
      indicator.querySelectorAll(".bs-media-split__dash")
    );
    if (panels.length < 2 || dashes.length !== panels.length) return;

    function activate(index) {
      dashes.forEach(function (dash, i) {
        dash.classList.toggle("is-active", i === index);
      });
    }

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        // o painel mais visivel manda; evita piscar no meio do swipe
        var best = null;
        entries.forEach(function (entry) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });
        if (best && best.intersectionRatio > 0.5) {
          activate(panels.indexOf(best.target));
        }
      },
      { root: scroller, threshold: [0.5, 0.75, 1] }
    );

    panels.forEach(function (panel) {
      observer.observe(panel);
    });

    section.__mediaSplitObserver = observer;
  }

  function init() {
    document
      .querySelectorAll('[data-section-type="media-split"]')
      .forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // o editor de temas recria a secao a cada alteracao
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector('[data-section-type="media-split"]');
    if (section) setup(section);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector('[data-section-type="media-split"]');
    if (section && section.__mediaSplitObserver) {
      section.__mediaSplitObserver.disconnect();
    }
  });
})();
